import {StatusReportWindow} from "./StatusReportWindow.js";
import {translate} from "@intermesh/goui";

translate.load(GO.lang.business.finance, "business", "finance")

export * from "./StatusReportWindow.js";

// Make report window backwards compatible with Ext.js
GO.finance = {
	StatusReportWindow: StatusReportWindow
}